module.exports = __webpack_public_path__ + "static/img/8105_phase_function_Paper_Points.f670572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8105_phase_function_Paper_Points.png
// module id = FDzc
// module chunks = 0